import { useContext, useEffect, useState } from "react";
import "./mobileCheckout.styles.scss";
import { RestOrderContext } from "../../../../contexts/restaurantOrder.context";
import { OrderTypeContext } from "../../../../contexts/orderType.context";
const MobileCheckout = () => {
  const [checkOutModal, setCheckoutModal] = useState(
    "mobile-checkout-modal-close"
  );
  const [tableInput, setTableInput] = useState("");
  const [tableNumberBool, setTableNumberBool] = useState(true);
  const { restOrderContext, orderTotal, setTableNumber, sendToKitchen } =
    useContext(RestOrderContext);
  const { orderTypeContext } = useContext(OrderTypeContext);

  useEffect(() => {
    if (orderTypeContext === "tableside") {
      setTableNumberBool(true);
    } else if (orderTypeContext === "takeaway") {
      setTableNumberBool(false);
    }
  }, [orderTypeContext]);
  const handleModalClose = () => {
    if (checkOutModal === "mobile-checkout-modal-close") {
      setCheckoutModal("mobile-checkout-modal-open");
    } else if (checkOutModal === "mobile-checkout-modal-open") {
      setCheckoutModal("mobile-checkout-modal-close");
    }
  };
  const handleChange = (e) => {
    const { value } = e.target;
    setTableInput(value);
    setTableNumber(value);
  };
  const handleClick = () => {
    if (orderTypeContext === "tableside" && tableInput === "") {
      console.log("Choose a tablenumber");
    } else if (orderTotal === 0) {
      console.log("Please add items to cart");
    } else {
      sendToKitchen();
      setTableInput("");
      handleModalClose();
    }
  };
  return (
    <div className="mobilecheckout-container">
      <div className="mobilecheckout-bottom">
        <div className="mc-bottom-left">
          <span>Order Total : {orderTotal}</span>
        </div>
        <div className="mc-bottom-right">
          <span className="mc-bottom-right-button" onClick={handleModalClose}>
            View and Send
          </span>
        </div>
      </div>
      <div className={checkOutModal}>
        <span className="mc-modal-back-button" onClick={handleModalClose}>
          Back to menu
        </span>
        {tableNumberBool && (
          <input
            type="text"
            placeholder=" Table Number"
            value={tableInput}
            className="mc-modal-input"
            onChange={handleChange}
          />
        )}
        <div className="mc-modal-box">
          <div className="mc-modal-box-header">
            <span className="mc-modal-box-header-details">Details</span>
            <span className="mc-modal-box-header-price">Price</span>
          </div>
          {Object.keys(restOrderContext).map((index) => {
            const tempObject = restOrderContext[index];
            const itemName = index.replace("_", " ");
            return (
              <div className="mc-modal-box-item">
                <div className="mc-modal-box-item-details">
                  <span className="mc-mb-item-name">{itemName}</span>
                  <span className="mc-mb-item-count">
                    {" "}
                    x {tempObject["itemCount"]}
                  </span>
                </div>
                <span className="mc-modal-box-item-price">
                  {tempObject["itemTotal"]}
                </span>
              </div>
            );
          })}
          <div className="mc-modal-box-total">
            <span className="mc-modal-total-title">Total</span>
            <span className="mc-modal-total-value">{orderTotal}</span>
          </div>
        </div>
        <div className="mc-modal-sendkitchen">
          <span className="mc-modal-sendkitchen-button" onClick={handleClick}>
            Send to kitchen
          </span>
        </div>
      </div>
    </div>
  );
};
export default MobileCheckout;
